import { ProviderContext, useSnackbar } from "notistack";
import React, { ReactNode } from "react";
import Toast from "./component";
import { FProps } from "./interface";

interface IProps {
  setUseSnackbarRef: (showSnackbar: ProviderContext) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  /* istanbul ignore next */
  props.setUseSnackbarRef(useSnackbar());
  /* istanbul ignore next */
  return null;
};

let useSnackbarRef: ProviderContext;
const setUseSnackbarRef = (useSnackbarRefProp: ProviderContext) => {
  /* istanbul ignore next */
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  );
};

/* istanbul ignore next */
const toastTypes = {
  success({
    title,
    message,
    messageAction,
    viewInfo,
    viewInfoOnSamePage
  }: FProps) {
    this.toast({
      title,
      message,
      messageAction,
      variant: "success",
      viewInfo,
      viewInfoOnSamePage
    });
  },
  /* istanbul ignore next */
  warning({
    title,
    message,
    messageAction,
    viewInfo,
    viewInfoOnSamePage
  }: FProps) {
    this.toast({
      title,
      message,
      messageAction,
      variant: "warning",
      viewInfo,
      viewInfoOnSamePage
    });
  },
  /* istanbul ignore next */
  info({
    title,
    message,
    messageAction,
    viewInfo,
    viewInfoOnSamePage,
    InfoOnSamePageName
  }: FProps) {
    this.toast({
      title,
      message,
      messageAction,
      variant: "info",
      viewInfo,
      viewInfoOnSamePage,
      InfoOnSamePageName
    });
  },
  /* istanbul ignore next */
  error({
    title,
    message,
    messageAction,
    viewInfo,
    viewInfoOnSamePage
  }: FProps) {
    this.toast({
      title,
      message,
      messageAction,
      variant: "error",
      viewInfo,
      viewInfoOnSamePage
    });
  },
  /* istanbul ignore next */
  toast({
    title,
    message,
    messageAction,
    variant = "error",
    viewInfo,
    viewInfoOnSamePage,
    InfoOnSamePageName,
    styleConfig
  }: {
    title: any;
    message?: ReactNode | string;
    messageAction?: ReactNode;
    variant?: string;
    viewInfo?: string;
    viewInfoOnSamePage?: string;
    InfoOnSamePageName?: string;
    styleConfig?: {};
  }) {
    /* istanbul ignore next */
    const options = {
      content: (key: any) => (
        <Toast
          id={key}
          title={title}
          message={message}
          messageAction={messageAction}
          variant={variant}
          viewInfo={viewInfo}
          viewInfoOnSamePage={viewInfoOnSamePage}
          InfoOnSamePageName={InfoOnSamePageName}
          styleConfig={styleConfig}
        />
      ),
      autoHideDuration: 5000
    };
    useSnackbarRef?.enqueueSnackbar("", options);
  }
};

export default toastTypes;
